import { ref, computed } from 'vue'
import moment from 'moment'
import 'moment/dist/locale/fr.js'

moment.locale('fr')

class Time {
  static format(time, dateFormat = 'DD MMMM YYYY', { lang = 'fr' } = {}) {
    moment.locale(lang)
    if (/^\d+$/.test(time)) time = parseInt(`${time}`)
    return moment(new Date(time)).format(dateFormat)
  }

  static between(start, end, { format, lang = 'fr' } = {}) {
    moment.locale(lang)
    if (/^\d+$/.test(start)) start = parseInt(`${start}`)
    if (/^\d+$/.test(end)) end = parseInt(`${end}`)

    const duration = moment.duration(moment(end).diff(moment(start)))

    if (format) {
      const totalSec = Math.floor(duration.asSeconds())
      const h = Math.floor(totalSec / 3600)
      const m = Math.floor((totalSec % 3600) / 60)
      const s = totalSec % 60

      return format
        .replace(/HH/g, String(h).padStart(2, '0'))
        .replace(/mm/g, String(m).padStart(2, '0'))
        .replace(/ss/g, String(s).padStart(2, '0'))
    }

    return {
      month: Math.floor(duration.asMonths()),
      day: duration.days(),
      hours: duration.hours(),
      min: duration.minutes(),
      sec: duration.seconds(),
    }
  }

  static since(
    time,
    { interval = 1000, format, lang = 'fr', autoStopDelay = 5000 } = {},
  ) {
    console.log('🚀 ~ Time ~ since ~ time:', time)
    moment.locale(lang)
    if (!time) time = Date.now()
    if (/^\d+$/.test(time)) time = parseInt(`${time}`)

    const past = moment(time)

    const computeDuration = () => {
      const now = moment()
      const duration = moment.duration(now.diff(past))

      if (format) {
        const totalSec = Math.floor(duration.asSeconds())
        const h = Math.floor(totalSec / 3600)
        const m = Math.floor((totalSec % 3600) / 60)
        const s = totalSec % 60

        return format
          .replace(/HH/g, String(h).padStart(2, '0'))
          .replace(/mm/g, String(m).padStart(2, '0'))
          .replace(/ss/g, String(s).padStart(2, '0'))
      }

      return {
        month: Math.floor(duration.asMonths()),
        day: duration.days(),
        hours: duration.hours(),
        min: duration.minutes(),
        sec: duration.seconds(),
      }
    }

    const state = ref(computeDuration())
    let lastUsed = Date.now()

    const comp = computed(() => {
      lastUsed = Date.now()
      return new String(state.value)
    })

    const timer = setInterval(() => {
      if (Date.now() - lastUsed > autoStopDelay) {
        clearInterval(timer)
        return
      }
      state.value = computeDuration()
    }, interval)

    // expose .get() pour déclencher la lecture manuellement
    comp.value.get = () => {
      lastUsed = Date.now()
      return state.value
    }

    return comp
  }
}

export default Time
